// removed by extract-text-webpack-plugin
module.exports = {"periodContainer":"_1LxhGu-3a2ly4sce8PrBU0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsPeriod/StatisticsPeriod.scss
// module id = 1330
// module chunks = 1